module.exports = __webpack_public_path__ + "img/syukyaku-top-011.2c5dc167.jpg";